import * as React from 'react';

import { UseIconProps, useIcon } from '../../useIcon';
import { IconTimerSvg } from './IconTimerSvg';

type TimerState = 'not-started' | 'active' | 'warning' | 'critical' | 'expired';
type TimerStatus = 'active' | 'paused';

export type IconTimerProps = UseIconProps & {
  state: TimerState;
  status?: TimerStatus;
};

export function IconTimer({
  state,
  status = 'active',
  ...props
}: IconTimerProps) {
  const iconProps = useIcon({ size: 'large', ...props });

  return <IconTimerSvg {...iconProps} state={state} status={status} />;
}
